import { h } from 'preact';
import { useCoreContext } from '../../../core/Context/CoreProvider';
import { SignOutButtonProps } from '../types';

export default function SignOutButton(props: Readonly<SignOutButtonProps>) {
    const { i18n } = useCoreContext();

    const handleClick = () => {
        new Promise((resolve, reject) => void props.onSignOut(resolve, reject))
            .then(() => {
                props.amazonRef.Pay.signout();
            })
            .catch(console.error);
    };

    return (
        <button
            type="button"
            className="adyen-checkout__button adyen-checkout__button--ghost adyen-checkout__amazonpay__button--signOut"
            onClick={handleClick}
        >
            {i18n.get('amazonpay.signout')}
        </button>
    );
}
